import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetCustomerListMutation, useGetCustomerGroupCountQuery } from "../../../../store/api/customer";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";

const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling,pageSize } = useScreenHeight();

  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [customerList, setCustomerList] = useState([]);
  const [customerDataApi] = useGetCustomerListMutation();
  const [totalrecords, setTotalrecords] = useState('');

  const [showFilters, setShowFilters] = useState(false);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);

  const [deleteDoc] = useDeleteDocMutation();
  const [delPopupVisible, setDelPopupVisible] = useState(false);
  const [delSelectedId, setDelSelectedId] = useState(null);
  const [delmessage, setDelmessage] = useState();
  const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);
  const { data: grpCount } = useGetCustomerGroupCountQuery();

  const filtersConfig = [
    { name: "siNo", label: "S. No.", width: "3.8%", type: "number" },
    { name: "name", label: "Customer Name", width: "15.7%", type: "text" },
    { name: "customer_group", label: "Customer Group", width: "15.7%", type: "text" },
    { name: "territory", label: "Territory", width: "15.7%", type: "text" },
    { name: "creation", label: "Date", type: "date", width: "15.7%" },
    {
      name: "disabled",
      label: "Status",
      width: "15.7%",
      type: "select",
      options: [
        { value: "0", label: "Enabled" },
        { value: "1", label: "Disabled" },
      ],
    },
  ];

  useEffect(() => {
    if (grpCount) {
      setTotalrecords(grpCount.message);
    }
  }, [grpCount]);

  const buildFilterArray = (filtersObj) => {
    return Object.entries(filtersObj)
      .filter(([key, value]) => value !== undefined && value !== "")
      .map(([key, value]) => {
        if (key === "creation") {
          return ["Customer", key, "like", `${value}%`];
        }
        if (["name", "customer_group", "territory"].includes(key)) {
          return ["Customer", key, "like", `%${value}%`];
        }
        if (key === "disabled") {
          return ["Customer", key, "=", value];
        }
        return ["Customer", key, "=", value];
      });
  };

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const rawFilterArray = buildFilterArray(filters);

      const payload = {
        page: currentPage,
        page_size: pageSize,
        ...(rawFilterArray.length > 0 && { search_input: rawFilterArray }),
      };

      const response = await customerDataApi(payload).unwrap();
      setTotalrecords(response.result.total_count);
      setCustomerList(response.result.customers);
    } catch (err) {
      console.error("Failed to fetch customers:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pageSize>0) {
      // console.log("fetch", pageSize)
      fetchCustomers();
    }
    }, [currentPage, filters, pageSize,screenHeight, screenScaling]);
  const [columnsConfig, setColumnsConfig] = useState([]);
   useEffect(()=>{
      setColumnsConfig(() => [
        {
          name: "S. No.",
          header: "S. No.",
          accessor: "siNo",
          width: "5%",
          visible: true,
          sortable: false,
          cellRenderer: (row, rowIndex) =>
            {  
            // console.log("cccccc", rowIndex, "vvvvvv", pageSize, "mnbvc", currentPage)
            return rowIndex + 1 + (pageSize * (currentPage - 1))
            }
        },
        {
          name: "Customer Name",
          header: "Customer Name",
          accessor: "name",
          width: "15.7%",
          visible: true,
          sortable: true,
        },
        {
          name: "Customer Group",
          header: "Customer Group",
          accessor: "customer_group",
          width: "15.7%",
          visible: true,
          sortable: true,
        },
        {
          name: "Territory",
          header: "Territory",
          accessor: "territory",
          width: "15.7%",
          visible: false,
          sortable: true,
        },
        {
          name: "Date",
          header: "Date",
          accessor: "creation",
          width: "15.7%",
          visible: true,
          cellRenderer: (row) => row.creation?.split(" ")[0],
        },
        {
          name: "Status",
          header: "Status",
          accessor: "disabled",
          width: "15.7%",
          visible: false,
          sortable: true,
          cellRenderer: (row) => {
            const isDisabled = row.disabled;
            const statusText = isDisabled === 0 ? "Enabled" : "Disabled";
            const color = isDisabled === 0 ? "#16A34A" : "#EF4444";
            return <span style={{ color }}>{statusText}</span>;
          },
        },
        {
          name: "Action",
          header: "Action",
          accessor: 'action',
          width: "0%",
          visible: true,
          sortable: false,
          cellRenderer: (row) => (
            <ActionButtonDropdown
              id={row.name}
              onView={() => handleView(row.name)}
              onEdit={() => handleEdit(row.name)}
              onDelete={() => handleDelete(row.name)}
            />
          ),
        },
      ])
   },[currentPage])
  const handleFilterChange = (newFilters) => {
    setCurrentPage(1);
    setFilters(newFilters);
  };

  const handleView = (id) => {
    navigate(`/master/customer/view-customer/`, { state: { PurchaseId: id } });
  };
  const handleEdit = (id) => {
    navigate(`/master/customer/edit-customer/`, { state: { PurchaseId: id } });
  };

  const handleDelete = (id) => {
    setDelSelectedId(id);
    setDelPopupVisible(true);
    setAlreadySubmitData(false);
    setDelmessage("Are you sure you want to Delete this Customer?");
  };

  const delHandleCancel = () => {
    setDelPopupVisible(false);
    setDelSelectedId(null);
  };

  const delHandleConfirm = async () => {
    try {
      await deleteDoc({
        doctype: "Customer",
        name: delSelectedId,
      }).unwrap();
      setDelmessage(`Customer ${delSelectedId} deleted successfully!`);
      setDelDone(true);
      setTimeout(() => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
        setDelDone(false);
        fetchCustomers();
      }, 1000);
    } catch (err) {
      console.error("Deletion Failed:", err);
      let errorMessage = "Failed to delete the Customer!";
      if (err?.data?._server_messages) {
        try {
          const messageArr = JSON.parse(err.data._server_messages);
          if (messageArr && messageArr.length > 0) {
            const messageObj = JSON.parse(messageArr[0]);
            if (messageObj?.message) {
              let fullMessage = messageObj.message;
              errorMessage = fullMessage.split("You must")[0].trim();
              errorMessage = errorMessage.replace(/<[^>]+>/g, "");
            }
          }
        } catch (parseError) {
          console.error("Error parsing server messages:", parseError);
        }
      }
      setDelPopupVisible(true);
      setDelmessage(errorMessage);
      setAlreadySubmitData(true);
    }
  };

  const handleSaveColumns = (selectedKeys, allFields) => {
		const updatedColumns = columnsConfig.map((column) => {
			return {
				...column,
				visible: selectedKeys.includes(column.accessor),
			};
		});
		setColumnsConfig(updatedColumns);
	};

  const visibleColumns = useMemo(
		() => columnsConfig.filter((col) => col.visible === true),
		[columnsConfig]
	);

  const defaultSelectedColumns = useMemo(
		() =>
			columnsConfig
				.filter((col) => col.visible === true)
				.map((col) => ({
					fieldname: col.accessor,
					label: col.name,
				}))
				.filter((col) => col.fieldname),
		[columnsConfig]
	);

  const activeFilterCount = useMemo(() => {
		return Object.values(filters).filter(
			(val) => val !== null && val !== undefined && val !== ""
		).length;
	}, [filters]);

  const actionButtons = [
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/customer/create-customer",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Customer"
    }
  ];
  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);
  return (
		<div
			className="container-fluid d-flex flex-column"
			style={{ flexGrow: "1" }}
		>
			<Tabs />
			<ListLayout
				breadcrumbItems={[
					{ label: "Customer" },
					{ label: "Customer List", style: { color: "#270B79" } },
				]}
				actionButtons={actionButtons}
			>
				{showFilters && (
					<ListFilters
						filtersConfig={filtersConfig}
						onFilterChange={handleFilterChange}
						currentFilters={filters}
						setShowFilters={setShowFilters}
					/>
				)}

				{showColumnConfig && (
					<ConfigureColumnsNew
						show={showColumnConfig}
						onClose={() => setShowColumnConfig(false)}
						onSave={handleSaveColumns}
						docType="Customer"
						defaultSelected={defaultSelectedColumns}
						fieldsData={columnsConfig.map((col) => ({
							fieldname: col.accessor,
							label: col.name,
						}))}
						disabledFields={[
							"siNo",
							"status",
							"action",
							"customer_group",
							"name",
						]}
					/>
				)}

				<Table
					key={currentPage}
					columns={visibleColumns}
					data={customerList}
					loading={loading}
				/>

				<Pagination
					setCurrentPage={setCurrentPage}
					pageSize={pageSize}
					totalRecords={totalrecords}
					currentPage={currentPage}
					className="mt-2 pb-3"
				/>

				{delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}

				{showExportPopup && (
					<ExportCSV
						doctype="Customer"
						fieldsData={accessors}
						onClose={() => setShowExportPopup(false)}
					/>
				)}
			</ListLayout>
		</div>
	);
};

export default MainContent;
